import type { FC } from 'react';
import React from 'react';
import classNames from 'clsx';
import { formatClassNames } from '@wix/editor-elements-common-utils';

import type { AvatarWrapperProps } from '../../../../LoginSocialBar.types';
import { AvatarIcon, AvatarState } from '../../../../LoginSocialBar.types';
import semanticClassNames from '../../LoginSocialBar.semanticClassNames';
import { Avatar } from './Avatar';

import newStyles from './Avatar.module.scss';
import oldStyles from './OLD_Avatar.module.scss';

export const AvatarWrapper: FC<AvatarWrapperProps> = ({
  id,
  isLoggedIn,
  avatarUri,
  userName,
  avatarIcon,
  customAvatar,
  useNewElementStructure,
}) => {
  const styles = useNewElementStructure ? newStyles : oldStyles;

  const isMemberInitials = isLoggedIn && avatarIcon === AvatarIcon.Initials;

  const shouldShowCustomAvatar =
    avatarIcon === AvatarIcon.Custom && !!customAvatar;

  const imageOrVector =
    avatarUri || shouldShowCustomAvatar
      ? AvatarState.Image
      : AvatarState.Vector;

  const avatarState =
    isMemberInitials && isLoggedIn ? AvatarState.Initials : imageOrVector;

  const isPlaceholder = avatarState === AvatarState.Vector;

  return (
    <div
      className={classNames(
        formatClassNames(semanticClassNames.avatarIcon),
        semanticClassNames.avatarIcon,
        styles.avatar,
        {
          [styles.withBorder]: !isPlaceholder,
          [styles.loggedOut]: !isLoggedIn,
        },
      )}
    >
      <Avatar
        id={id}
        name={userName}
        url={shouldShowCustomAvatar ? customAvatar : avatarUri}
        state={avatarState}
        className={classNames({
          [styles.memberInitials]: isMemberInitials,
          [styles.avatarPlaceholder]: isPlaceholder,
        })}
      />
    </div>
  );
};
